import ColorSwatch from "./color-swatch";

export default ColorSwatch;
